module.exports = __webpack_public_path__ + "img/animal-rescue-mission-logo.469d6ae6.jpg";